// types
import { Status } from '../../../@types';

// router
import { useTranslation } from 'react-i18next';

// mui
import { Chip, ChipProps, Tooltip, Typography } from '@mui/material';

// utils
import { translateStatus, translateStatusTooltip } from '../../../utils/translations';

// props
export interface ChipStatusProps extends ChipProps {
	hasTooltip?: boolean;
	status: null | Status | undefined;
}

export const ChipStatus = ({
	color = 'default',
	hasTooltip = true,
	status,
	...props
}: ChipStatusProps) => {
	// hooks
	const { t } = useTranslation();

	const colors: Record<Status, ChipProps['color']> = {
		ACTIVE: 'success',
		APPROVED: 'success',
		COMPLETED: 'success',
		CREATED: 'success',
		DEACTIVATED: 'error',
		DELETED: 'default',
		DISABLED: 'error',
		DONE: 'success',
		DRAFT: 'warning',
		ENABLED: 'success',
		ERROR: 'error',
		FAILED: 'error',
		FINALIZED: 'info',
		HIGH: 'success',
		INACTIVE: 'default',
		INDETERMINATE: 'default',
		IN_PROGRESS: 'warning',
		INVITED: 'info',
		LOW: 'error',
		MINIMAL: 'warning',
		MODERATE: 'info',
		PENDING: 'default',
		READY: 'warning',
		REJECTED: 'error',
		RETRY: 'default',
		REVERTED: 'default',
		REVISION: 'info',
		STARTED: 'info',
		TRIAL: 'default',
	};

	if (!status) {
		return <Typography>{t('na')}</Typography>;
	}

	const chip = (
		<Chip
			color={colors[status] || color}
			label={translateStatus(status, t)}
			size="small"
			variant="twoTone"
			{...props}
		/>
	);

	const tooltip = translateStatusTooltip(status, t);

	if (hasTooltip && tooltip !== status) {
		return (
			<Tooltip arrow={true} placement="top" title={tooltip}>
				{chip}
			</Tooltip>
		);
	}

	return chip;
};
